module.exports = __webpack_public_path__ + "static/media/image-video-1.2cd31fad.png";